import { dateToShow } from '@/helpers/dates'

export default {
  prepareShow (employee) {
    employee.birthdate = dateToShow(employee.birthdate)

    return employee
  },
  doDeleteWithoutConfirmation (entity) {
    this.currentEntity = entity
    if (!this.beforeDelete(entity)) {
      return
    }

    this.$resource.delete(entity.id + '/detach')
      .then(({data}) => {
        this.afterDelete(entity, data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/index/resources/methods.js